<template>
  <div class="button-holder top-btn-holder">
    <div class="btn-item back-item">
      <button class="back" v-if="isNeedBack" @click="isEditTrade = false; isNewTrade = false">
        <img class="long-arrow light-arrow" src="/img/long-arrow.png" alt="">
        <img class="long-arrow dark-arrow" src="/img/long-arrow-dark.png" alt="">
        <span>Special Trades</span>
      </button>
    </div>
   <div class="btn-item">
     <button class="btn" @click="newTrade()">New Special Trade</button>
   </div>
  </div>
</template>

<script>
export default {
  name: "ProgramHead",
  props: {
    isNeedBack : Boolean,
  },
  computed: {
    isNewTrade: {
      get() {
        return this.$store.state.isNewTrade;
      },
      set(value) {
        this.$store.commit('setter', {isNewTrade: value})
      }
    },
    isEditTrade: {
      get() {
        return this.$store.state.isEditTrade;
      },
      set(value) {
        this.$store.commit('setter', {isEditTrade: value})
      }
    },
  },
  methods: {
    newTrade() {
      this.isNewTrade = !this.isNewTrade;
    },
  }
}
</script>

<style lang="scss">
.btn-item {
  width: 50%;

  &.back-item {
    display: flex;
  }
}
</style>
